// ЗАМЕНА ЗАГОЛОВКОВ И В OFFCANVAS С ФОРМАМИ И ДОБАВЛЕНИЕ ТЕМЫ В СООБЩЕНИИ В TELEGRAM В ЗАВИСИМОСТИ ОТ ТИПА ФОРМЫ

export function setFormTitleAndSubject({ btn, subject: formSubjectElement = '.form [type="hidden"]',  title: formTitleElement = '.off-title' } = {}) {
    const formButtons = document.querySelectorAll('.o_form')
    
    formButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Установка заголовка offcanvas из атрибута data-title
            const dataTitle = this.dataset.title
            const formTitleEl = document.querySelector(formTitleElement)
            
            if (dataTitle && formTitleEl) {
                formTitleEl.innerText = dataTitle
            }
            
            // Установка темы сообщения из атрибута data-name
            const formSubjectEl = document.querySelector(formSubjectElement)
            const attrName = this.dataset.name
            
            if (formSubjectEl) {
                if (attrName) {
                    formSubjectEl.value = attrName
                } else {
                    formSubjectEl.value = 'Сообщение из формы'
                }
            }
        })
    })
}
